<template>
  <ExpenseGroup :type="8" />
</template>
<script route="/fin/expense_group_invoice">
  import ExpenseGroup from '../expense_group/expense_group';
  export default {
    components: {ExpenseGroup}
  }
</script>
